<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="container-fluid container-p-x pb-3 myflex">
      <div><a href="http://microtronics.com" class="footer-link pt-3">microtronics.com</a></div>
      <div>
        <a href="#" class="footer-link pt-3 ml-4">Help</a>
        <a href="#" class="footer-link pt-3 ml-4">Support</a>
        <a href="#" class="footer-link pt-3 ml-4">API-Playground</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',

  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  }
}
</script>

<style scoped>
  .myflex {
    display: flex;
    justify-content: space-between;
  }
</style>
